import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageMap, {
  fallbackLanguage,
  i18nResources,
  supportedLanguages,
} from './config/languages';

const fallback = supportedLanguages.includes(fallbackLanguage)
  ? fallbackLanguage
  : supportedLanguages[0];

i18n.use(initReactI18next).init({
  resources: i18nResources,
  fallbackLng: [fallback], // fallback language default

  detection: {
    checkWhitelist: true,
  },

  debug: false,

  whitelist: supportedLanguages,
  supportedLngs: supportedLanguages,

  interpolation: {
    escapeValue: false,
  },
});

export const languageConfig = languageMap;

export default i18n;
